/// <amd-module name="Artifacts/Cargo/CargoProtocol" />
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  createBadgeCommand,
  createDeleteCommand,
  createDownloadCommand,
  createGetLinkCommand,
  createPermanentDeleteCommand,
  createPromoteCommand,
  createRestoreCommand,
  createUpstreamOverrideCommand,
  createYankCommand,
} from "Artifacts/Cargo/commands";
import { CargoAttributes } from "Artifacts/Cargo/components/CargoPackageAttributes";
import { CargoOverview } from "Artifacts/Cargo/components/CargoPackageOverview";
import { logoContributionId } from "Artifacts/Cargo/components/Logo";
import { CargoModule } from "Artifacts/Cargo/redux/";
import { IFeedCargoDataService } from "Artifacts/Cargo/services/CargoDataService";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { UpstreamVersionVisibility } from "Artifacts/Root/types/PackagingShared";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export class CargoProtocol implements IProtocol {
  public readonly id = "Cargo";
  public readonly name = "Cargo";
  public readonly statusUrl = "https://status.crates.io/";

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    const commands = [
      createPromoteCommand(pageContext, versions),
      createDownloadCommand(pageContext, versions, feed),
      createPermanentDeleteCommand(pageContext, versions, feed),
      createRestoreCommand(pageContext, versions),
      createDeleteCommand(pageContext, versions, feed),
      createBadgeCommand(pageContext, versions, feed),
      createUpstreamOverrideCommand(pageContext),
      createGetLinkCommand(pageContext, versions, feed),
      createYankCommand(pageContext, versions, feed),
    ].filter((x) => x !== undefined) as ICommand[];

    return commands;
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return CargoOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return CargoAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return CargoModule;
  }

  public async getUpstreamOverrideStatus(
    pageContext: IVssPageContext,
    packageName: string,
    feed?: IFeed,
  ): Promise<boolean> {
    if (!feed) {
      return false;
    }
    const dataService = pageContext.getService<IFeedCargoDataService>("IFeedCargoDataService");
    const overrideBehavior = await dataService.getUpstreamingBehavior(
      feed?.id,
      packageName,
      feed?.project?.id,
    );
    return (
      overrideBehavior?.versionsFromExternalUpstreams ===
      UpstreamVersionVisibility.AllowExternalVersions
    );
  }

  public getUpstreamingProperties(pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: true,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: true,
      isAadUpstreamsSupported: true,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return (
      isFeatureFlagEnabled(pageContext, "Packaging.Feed.Cargo.EnableUI", false) ||
      isFeatureFlagEnabled(pageContext, "Packaging.Feed.Cargo.EnableUI.MSFT", false)
    );
  }
}

ProtocolService.registerProtocol(new CargoProtocol());
